module.exports = __webpack_public_path__ + "img/adouy4.69827f6f.png";